import { mergeDeep } from 'as-ui-kit/utils/objects';

export const getStateIfFn = getState => (typeof getState === 'function' ? getState() : getState);

export const modifyArrayState = (state, pos, element, addToEnd = false) =>
    mergeDeep([], modifyArrayStateNoCopy(state, pos, element, { addToEnd }));

export const modifyArrayStateNoCopy = (state, pos, element, { isToggle = false, addToEnd = false } = {}) =>
    (isToggle ? pos < 0 && element != null : element)
        ? pos >= 0
            ? [...state.slice(0, pos), element, ...state.slice(pos + 1)]
            : addToEnd
                ? [...state.slice(), element]
                : [element, ...state.slice()]
        : pos >= 0
            ? [...state.slice(0, pos), ...state.slice(pos + 1)]
            : state;
